"use client";

import { cn } from "@tillix/ui-atoms/lib/utils";
import { Separator } from "@tillix/ui-atoms/separator";
import { useT } from "@/features/i18n/hooks/use-t";

export default function OrSeparator({ className }: { className?: string }) {
  const { t } = useT();
  return (
    <div
      className={cn(
        "my-4 flex items-center justify-center text-tenant-howard-county-primary-dark-gray",
        className,
      )}
    >
      <Separator className="flex-1" />
      <span className="mx-2 text-black text-xs">{t("auth.or")}</span>
      <Separator className="flex-1" />
    </div>
  );
}
